<template>
  <!-- Experience Modal -->
  <div id="edit_banked_time_modal" class="modal custom-modal fade" role="dialog" ref="myModal">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Value</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="Close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-scroll">
              <div class="row">
                <div class="col-12">

                  <div class="input-block mb-3">
                    <h6 class="mt-3">
                      Value must be in hour:minute format
                    </h6>
                    <div class="mt-3">
                      <input class="form-control" type="text" v-model="valueInMins" />
                    </div>

                  </div>

                  <div class="mb-3">
                    <h6 class="mt-3">
                      Value is positive/negative
                    </h6>
                    <!-- <div class="mt-3 d-flex flex-wrap gap-3"> -->
                    <div class="mt-3">
                      <div class="form-check form-check-inline" v-for="option in userOptions" :key="option.value">
                        <input class="form-check-input" type="radio" :id="option.value" name="userType"
                          :value="option.value" v-model="isPositive" />
                        <label class="form-check-label" :for="option.value">{{ option.label }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="input-block mb-3">
                    <h6 class="mt-3">
                      Comment
                    </h6>
                    <div class="mt-3">
                      <input class="form-control" type="text" v-model="comment" />
                    </div>

                  </div>
                </div>
                <div class="col-12">


                </div>


              </div>


            </div>


            <div class="submit-section">
              <button class="btn btn-primary submit-btn" type="button" @click="submit">
                <span v-if="!loader">Submit</span>
                <div class="d-flex justify-content-center text-center py-1 px-5" v-else>
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Experience Modal -->


</template>
<script>
// import { ref } from "vue";
import axios from 'axios';
import { VUE_APP_API_BASE_URL } from "../../config";
import { minToTimeString } from "@/utils/util-funcitons";

export default {
  data() {
    return {
      select2: null,
      isPositive: true,
      comment: '',
      valueInMins: 0,
      loader: false,
      bankedTimeId: '',
      userType: '', // or default: 'staff'
      userOptions: [
        { label: 'Positive', value: true },
        { label: 'Negative', value: false }
      ],

    };
  },
  mounted() {

  },
  methods: {

    updateValues(item) {
      let value = Math.abs(item.work_in_minutes)
      this.bankedTimeId = item.id,
        this.isPositive = !this.isNegative(item.work_in_minutes),
        this.valueInMins = this.toTimeString(value),
        this.comment = item.comment
    },

    toTimeString(minutes) {
      return minToTimeString(minutes);
    },

    isNegative(number) {
      return number < 0;
    },

    timeStringToInt(timeStr) {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    },

    submit() {
      this.loader = true;
      axios.post(`${VUE_APP_API_BASE_URL}/task/${this.bankedTimeId}/edit`, {
        value: this.timeStringToInt(this.valueInMins),
        is_positive: this.isPositive,
        comment: this.comment
      })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.$router.go(0)
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },


    okClicked() {
      if (this.userType === 'staff' && this.selectedUsers.length == 0) {
        this.$toast.error("No users selected");
        return;
      }

      this.$emit('onUsersSelected', {
        type: this.userType,
        selectedUsers: this.selectedUsers,
        selectedLocations: this.selectedLocations
      });
      this.selectedUsers = [];
      this.selectedLocations = [];
      this.selectedRoles = [];
      this.$refs.Close.click();
    },
  },

};
</script>
